import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import Drawer from '../../../components/Drawer'
import ChangeHistory from '../../../features/components/ChangeHistoryDrawer/ChangeHistory'

import useManageDrawer from '../../../hooks/formHooks/useManageDrawer'

import { campaignsSelector } from '../../../modules/selectors/campaigns'

import { CHANGE_CAMPAIGN_HISTORY } from '../../../constants/forms'
import { TYPE_CAMPAIGN } from '../../../constants/changeHistory'

function CampaignsChangeHistory({ platform }) {
  const campaigns = useSelector(campaignsSelector)
  const { isFormOpen, handleFormClose, selectedEditItemId } = useManageDrawer({ formName: CHANGE_CAMPAIGN_HISTORY })

  const selectedCampaignData = useMemo(
    () => selectedEditItemId && campaigns.find(({ id }) => id === selectedEditItemId),
    [selectedEditItemId, campaigns]
  )
  const historyDrawerTitle = `Change History for '${selectedCampaignData?.name}'`

  return (
    <Drawer isOpen={isFormOpen} onClose={handleFormClose} title={historyDrawerTitle || 'Change History'}>
      <ChangeHistory historyType={TYPE_CAMPAIGN} platform={platform} itemId={selectedEditItemId} />
    </Drawer>
  )
}

CampaignsChangeHistory.propTypes = {
  platform: PropTypes.string.isRequired
}

export default CampaignsChangeHistory
